<template>
  <div class="app-container"> 
        <el-form :model="queryParams" ref="queryForm" :inline="true" style="overflow: hidden; clear: both;">
          <el-form-item label="服务编号" class="f-item">
            <el-input
             style="width: 300px;"
              v-model="queryParams.serviceNo"
              placeholder="请输入服务编号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="主合同名称" class="f-item">
            <el-input
              style="width: 300px;"
              v-model="queryParams.mainContractName"
              placeholder="请输入主合同名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="证书编号" class="f-item">
            <el-input
             style="width: 300px;"
              v-model="queryParams.certificateNo"
              placeholder="请输入证书编号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="提交时间">
              <el-date-picker
                  style="width: 300px"
                  format="yyyy-MM-dd" 
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  v-model="submitTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="上链时间">
              <el-date-picker
                  style="width: 300px"
                  format="yyyy-MM-dd" 
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  v-model="blockchainDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="当前状态" prop="status">
              <el-select v-model="queryParams.status" placeholder="请选择当前状态" clearable size="small">
              <el-option
                  v-for="dict in stateOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
              ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="合同类型" prop="contractType">
            <el-select v-model="queryParams.contractType" placeholder="请选择合同类型" clearable size="small">
              <el-option
                v-for="dict in contractOptions"
                :key="dict.dictValue"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="纠纷解决机构" prop="disputeResolutionOrgOne">
            <el-select v-model="queryParams.disputeResolutionOrgOne" placeholder="请选择纠纷解决机构" clearable size="small">
              <el-option
                v-for="dict in institutionOptions"
                :key="dict.dictValue"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="纠纷解决机构" prop="disputeResolutionOrgTwo">
            <el-input
              v-model="queryParams.disputeResolutionOrgTwo"
              placeholder="请输入纠纷解决机构"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />           
          </el-form-item>
          <el-form-item >
            <el-button type="orange" size="mini" @click="handleQuery">搜索</el-button>
            <el-button size="mini" @click="resetQuery" style="padding:0 15px;">重置</el-button>
          </el-form-item>
        </el-form>
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="orange"
              icon="el-icon-plus"
              size="mini"
              @click="handleAddC"
            >新建消费投资服务</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
              type="orange"
              icon="el-icon-s-order"
              size="mini"
              @click="downloadFile"
            >服务文件下载</el-button>
          </el-col>
          <!-- <el-col :span="1.5">
            <el-button
              type="warning"
              icon="el-icon-download"
              size="mini"
              @click="handleExport"
            >导出</el-button>
          </el-col> -->
        </el-row>

    <el-table v-loading="loading" stripe :data="arbitrateRecords">
      <el-table-column  type="index" label="序号" width="70" align="center"/>
      <el-table-column label="服务编号" align="center" prop="serviceNo" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status != '0'">{{ scope.row.serviceNo }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="主合同名称" align="center" prop="mainContractName" min-width="120"/>
      <el-table-column label="合同类型" align="center" prop="contractType" min-width="120" :formatter="contractFormat"/>
      <el-table-column label="证书编号" align="center" prop="certificateNo" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '5' || scope.row.status == '9'">{{ scope.row.certificateNo }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="主合同金额（万元）" align="center" prop="mainContractAmount" width="160">
        <template slot-scope="scope">
          {{setComdify(scope.row.mainContractAmount, 4)}}
				</template>
			</el-table-column>
      <el-table-column label="共识金额（万元）" align="center" prop="consensusAmount" width="160">
        <template slot-scope="scope">
          {{setComdify(scope.row.consensusAmount, 4)}}
				</template>
			</el-table-column>
      <el-table-column label="纠纷解决机构" align="center" prop="disputeResolutionOrgTwo" min-width="120"/>
      <el-table-column label="提交时间" align="center" prop="submitTime" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.status != '0'">{{ scope.row.submitTime }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="通告查询码" align="center" prop="checkCode" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '5' || scope.row.status == '9'">{{ scope.row.checkCode }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="上链时间" align="center" prop="blockchainDate" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '5' || scope.row.status == '9'">{{ scope.row.blockchainDate }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="当前状态" align="center" prop="status" width="160" :formatter="stateFormat"></el-table-column>
      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <span class="f-blue" v-if="scope.row.status != '0'" @click="goDetail(scope.row)">详情</span>
          <span class="f-blue" v-if="scope.row.status == '0' || scope.row.status == '2' || scope.row.status == '4' || scope.row.status == '7'" style="margin-left: 10px;" @click="handleEdit(scope.row)">编辑</span>
          <span class="f-blue" v-if="scope.row.status == '0' || scope.row.status == '2' || scope.row.status == '4' || scope.row.status == '7'" style="margin-left: 10px;" @click="handleDel(scope.row)">删除</span>
          <span class="f-blue" v-if="scope.row.status != '0' && scope.row.status != '5'" @click="preview(scope.row)" style="margin-left: 10px;">预览链证报告</span>
          <span class="f-blue" v-if="scope.row.status == '5'" @click="download(scope.row)" style="margin-left: 10px;">下载链证报告</span>
          <span class="f-blue" v-if="scope.row.status == '5'" @click="viewPah(scope.row)" style="margin-left: 10px;">查看备案函</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="toolbar">
        <el-pagination class="b-orange" background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize" :total="total">
        </el-pagination>
    </div>

  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
import { download } from "@/api/utils";
export default {
  name: "contract",
  components: {

  },
  data() {
    return {
      setComdify: this.comdify,
      loading: true,
      checkLoading: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      submitTime: [],
      blockchainDate: [],
      total: 0,
      arbitrateRecords: [],
      account: sessionStorage.account,
      idNo: '',
      companyType: '',
      typeOptions: [],
      contractOptions: [],
      institutionOptions: [],
      stateOptions: [],
      sceneType: this.$route.query.sceneType,
      checkParams: {
        platform: 4,
      }
    }
  },
  watch: {
      // 监听路由变化
      "$route.query": function(newVal, oldVal) {
          this.queryParams = {
            pageNum: 1,
            pageSize: 10,
          }
          this.sceneType = newVal.sceneType
          this.getList()
      }
  },
  created() {
    this.$api.api.getDicts("gyl_state").then(response => {
        this.stateOptions = response.data;
    });
    this.$api.api.getDicts("xf_save_type").then(response => {
        this.typeOptions = response.data;
    });
    this.$api.api.getDicts("xf_contract_type").then(response => {
        this.contractOptions = response.data;
    });
    this.$api.api.getDicts("xf_dispute_solve_institution").then(response => {
        this.institutionOptions = response.data;
    });

    this.getList()
    this.getInf()
  },
  methods: {
    goDetail(row){
      this.$router.push(`/conDetail?id=${row.id}`);
    },
    selectDictLabel(datas, value) {
      var actions = [];
      Object.keys(datas).some((key) => {
        if (datas[key].dictValue == ('' + value)) {
          actions.push(datas[key].dictLabel);
          return true;
        }
      })
      return actions.join('');
    }, 
    typeFormat (val) {
      return this.selectDictLabel(this.typeOptions, val);
    }, 
    stateFormat (row) {
      return this.selectDictLabel(this.stateOptions, row.status);
    }, 
    contractFormat (row) {
      return this.selectDictLabel(this.contractOptions, row.contractType);
    },
    getInf(){
      this.$api.api.iaccGetInfoByAccount({account: this.account}).then(response => {
        this.companyType = response.data.companyType
        this.idNo = response.data.idNo
        this.checkParams.projectName = response.data.companyCn
        this.checkParams.socialCode = response.data.job
        sessionStorage.projectName = response.data.companyCn
        sessionStorage.socialCode = response.data.job
        sessionStorage.applyCustomerName = response.data.applyCustomerName
        sessionStorage.applyCustomerContact = response.data.applyCustomerContact
        sessionStorage.applyCustomerAccount = response.data.applyCustomerAccount
      });
    },
    handleCurrentChange(val) { // 查询list
      this.queryParams.pageNum = val;
      this.getList();
    }, 
    getList() {
      if(this.submitTime){
        this.queryParams.submitStartTime = this.submitTime[0]
        this.queryParams.submitEndTime = this.submitTime[1]
      }
      if(this.blockchainDate){
        this.queryParams.blockchainStartDate = this.blockchainDate[0]
        this.queryParams.blockchainEndDate = this.blockchainDate[1]
      }
      this.queryParams.createBy = this.account;
      let queryParams = Object.assign({}, this.queryParams);
      this.$api.consumer.proList(queryParams).then(response => {
        this.loading = false
        if(response.code==200){
          this.arbitrateRecords = response.rows;
          this.total = response.total;
        }else {
          this.$message.error(response.msg);
        }    
      });
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10
      }
      this.submitTime=[]
      this.blockchainDate= []
      this.handleQuery();
    },
    preview(row){
      this.reportDownload(baseUrl.iaccUrl + '/iacc-contract-platform/contract/consumer/project/contractReportPreview/'+row.id, 
      `contractReportPreview_${new Date().getTime()}.pdf`)
    },
    download(row){
      this.reportDownload(baseUrl.iaccUrl + '/iacc-contract-platform/contract/consumer/project/contractReport/'+row.id+'?response-content-type=application/octet-stream', 
      `contractReport_${new Date().getTime()}.pdf`)
    },
    viewPah(row){
      this.$router.push({path: '/filingLetter', query: {id: row.id}}); 
    },
    handleAddC(){
      this.checkLoading = this.$loading({
        lock: true,
        text: "查询中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 判断黑名单
      this.$api.api.checkInBlacklist(this.checkParams).then(res => {
        if(res.code == '00000000') {
          if(res.content.checkResult){
            this.checkLoading.close();
            this.$alert('黑名单企业禁入，如有疑问联系数据方处理', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                return false
              }
            });
          }else{
            //灰名单
            this.$api.api.checkInGreylist(this.checkParams).then(res => {
              this.checkLoading.close();
              if(res.contentGrey.checkResult){
                this.$alert('灰名单企业，请关注业务风险，可做存储', '提示', {
                  confirmButtonText: '确定'
                });
              }       
            });
            sessionStorage.removeItem("setpForm")
            this.$router.push({path: '/addConsumption'}); 
          }
        }else {
          this.checkLoading.close();
          this.$message.error(res.msg)
        }
        
      });      
    },    
    handleEdit(row){
      sessionStorage.removeItem("setpForm")
      this.$router.push(`/addConsumption?id=${row.id}`);
    },
    handleDel(row){
      this.$confirm("确定删除此条消费投资服务吗？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$api.consumer.delProject(row.id).then(response => {
          if(response.code==200){
            this.$message.success("删除成功！")
            this.getList();
          }else {
            this.$message.error(response.msg);
          }    
        });
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm("确定导出此项目信息吗？", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          return this.$api.consumer.exportProject(queryParams);
        }).then(response => {
          this.download(response.msg);
        })
    },
    downloadFile(){
      this.$api.api.serviceFile('5')
    }
  }
}
</script>

<style>
.wrap{word-wrap:break-word; word-break:break-all;}
.el-button:focus, .el-button:hover{
  color: #DDB642;
  border-color: #DAA513;
  background-color: #F7F1DF;
}
</style>
